import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyWhatsApp from "@/components/StickyWhatsApp";
import { PDI_TOOLS, IMAGES } from "@/data/content";
import { openWhatsApp } from "@/lib/api";

export default function PDILanding() {
  return (
    <main className="relative bg-void text-silver" data-testid="pdi-landing-page">
      <Navbar />

      <section className="relative pt-40 md:pt-48 pb-20 md:pb-28 bg-void grain" data-testid="pdi-landing-hero">
        <div className="max-w-[1000px] mx-auto px-5 md:px-10">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full glass gradient-border"
          >
            <span className="w-2 h-2 rounded-full gradient-bg wa-pulse flex-shrink-0" />
            <span className="eyebrow !text-[13px] gradient-text font-bold">The PDI Toolkit</span>
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.1 }}
            className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight"
          >
            Negotiation gets you the deal. <span className="italic gradient-text">PDI protects it.</span>
          </motion.h1>
          <p className="mt-6 text-lg md:text-xl text-silver/75 max-w-2xl leading-relaxed">
            Our 60+ point advisor-guided remote inspection gives you a structured way to review the car before delivery —
            upload photos checkpoint-by-checkpoint, get advisor sign-off, and receive a branded PDI report.
          </p>
          <button
            onClick={() => openWhatsApp({ source: "pdi_landing_hero" })}
            className="mt-10 inline-flex items-center gap-2.5 px-7 py-4 rounded-full text-sm md:text-base font-medium text-white gradient-bg shadow-[0_20px_60px_-15px_rgba(139,92,246,0.6)] hover:scale-[1.03] transition-transform"
            data-testid="pdi-landing-cta"
          >
            Get My PDI
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>

      <section className="relative py-16 md:py-20 bg-[#0A0A0F]" data-testid="pdi-landing-tools">
        <div className="max-w-[1000px] mx-auto px-5 md:px-10">
          <p className="eyebrow gradient-text">Six instruments. Zero blind spots.</p>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {PDI_TOOLS.map((t) => (
              <div key={t.name} className="rounded-2xl border border-white/5 bg-surface p-6">
                <div className="font-serif text-xl text-white leading-tight">{t.name}</div>
                <div className="mt-2 text-sm text-silver/70 leading-relaxed">{t.body}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-16 md:py-20 bg-void" data-testid="pdi-landing-image">
        <div className="max-w-[1000px] mx-auto px-5 md:px-10">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 h-72 md:h-96">
            <img src={IMAGES.pdi} alt="Inspection tools" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-void/95 via-void/40 to-transparent" />
          </div>
        </div>
      </section>

      <section className="relative py-20 md:py-28 bg-[#0A0A0F] text-center" data-testid="pdi-landing-final-cta">
        <div className="max-w-[1000px] mx-auto px-5 md:px-10">
          <p className="font-serif text-3xl md:text-5xl text-white leading-tight">
            Don't drive away with <span className="italic gradient-text">someone else's problem.</span>
          </p>
          <button
            onClick={() => openWhatsApp({ source: "pdi_landing_final" })}
            className="mt-8 inline-flex items-center gap-2.5 px-7 py-4 rounded-full text-sm md:text-base font-medium text-white gradient-bg shadow-[0_20px_60px_-15px_rgba(139,92,246,0.6)] hover:scale-[1.03] transition-transform"
          >
            Get My PDI
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>

      <Footer />
      <StickyWhatsApp />
    </main>
  );
}
